// @flow
import * as React from 'react';
import type { UIProps } from '@ta/social.section-core';
import { FeedSectionPhotoCarousel } from '@ta/social.section-core';

/**
 * This component just manages the currently displayed index for you.
 * Use this if you don't care about the currently displayed image
 *
 */

const ManagedFeedSectionPhotoCarousel = (props: UIProps) => {
  const [currentlyDisplayedIndex, setCurrentlyDisplayedIndex] = React.useState(0);

  return (
    <FeedSectionPhotoCarousel
      {...props}
      currentlyDisplayedIndex={currentlyDisplayedIndex}
      onPhotoChange={setCurrentlyDisplayedIndex}
    />
  );
};

export default ManagedFeedSectionPhotoCarousel;
